<template>
  <label
    v-for="option in options"
    :key="option.partnerId"
    class="tw:block"
    :class="option.isActive ? 'tw:cursor-pointer' : 'tw:cursor-default'"
  >
    <input
      type="radio"
      :value="option.partnerId"
      :checked="selectedPartner === option.partnerId"
      @change="handleOptionChange(option)"
      class="tw:sr-only tw:peer"
    />

    <div
      class="tw:flex tw:items-center tw:justify-between tw:p-4 tw:bg-white tw:border tw:border-gray-300 tw:rounded-lg tw:transition-all tw:hover:border-gray-300 peer-checked:tw:border-blue-500 peer-checked:tw:bg-blue-50"
    >
      <div class="tw:flex tw:items-center tw:gap-3 tw:w-full">
        <div
          aria-hidden="true"
          class="tw:flex tw:items-center tw:justify-center tw:rounded-full tw:h-4 tw:w-4 tw:border"
          :class="
            selectedPartner === option.partnerId
              ? 'tw:border-blue-800 tw:bg-blue-500 tw:border-2'
              : 'tw:border-gray-400'
          "
        >
          <div
            class="tw:rounded-full tw:h-[8px] tw:w-[8px] tw:border tw:border-blue-800 tw:bg-white"
            :class="selectedPartner === option.partnerId ? 'tw:block' : 'tw:hidden'"
          />
        </div>

        <div class="tw:flex tw:items-center tw:justify-between tw:w-full">
          <span class="tw:font-bold tw:text-sm tw:uppercase" :class="{ 'tw:text-gray-500': !option.isActive }">
            {{ option.partnerName }}
          </span>

          <div class="tw:flex tw:items-center tw:gap-6">
            <span
              v-if="option.partnerStatus === 5 && option.connectionStatus === 5"
              class="tw:text-green-700 tw:font-bold tw:text-sm"
            >
              {{ $t('rc_provider_status_active') }}
            </span>
            <span v-else class="tw:text-black tw:text-sm tw:font-bold tw:flex tw:items-center tw:gap-1">
              <UiTooltip theme="material" tooltip-position="top" :label="$t('rc_provider_inactive_tooltip')">
                <InformationOutline class="tw:fill-none tw:stroke-gray-600 tw:h-6 tw:w-6 tw:ml-2" />
              </UiTooltip>
              {{ $t('rc_provider_status_inactive') }}
            </span>
            <span class="tw:text-sm tw:text-black">
              {{ option.canNetCpa ? $t('rc_pay_per_stay') : $t('rc_pay_per_click') }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </label>
</template>

<script setup>
import UiTooltip from '@/components/dashboard/ui/UiTooltip.vue'
import InformationOutline from '@/components/icons/InformationOutline.svg?component'

const emit = defineEmits(['handleOptionChange'])
const handleOptionChange = option => {
  if (!option.isActive) return
  emit('handleOptionChange', option.partnerId)
}
defineProps({ options: Array, selectedPartner: Number })
</script>
